/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MasterItemUpdateBase } from './MasterItemUpdateBase';
import {
    MasterItemUpdateBaseFromJSON,
    MasterItemUpdateBaseFromJSONTyped,
    MasterItemUpdateBaseToJSON,
    MasterItemUpdateBaseToJSONTyped,
} from './MasterItemUpdateBase';

/**
 * 
 * @export
 * @interface MasterItemUpdate
 */
export interface MasterItemUpdate {
    /**
     * 
     * @type {Array<MasterItemUpdateBase>}
     * @memberof MasterItemUpdate
     */
    body: Array<MasterItemUpdateBase>;
}

/**
 * Check if a given object implements the MasterItemUpdate interface.
 */
export function instanceOfMasterItemUpdate(value: object): value is MasterItemUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function MasterItemUpdateFromJSON(json: any): MasterItemUpdate {
    return MasterItemUpdateFromJSONTyped(json, false);
}

export function MasterItemUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MasterItemUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(MasterItemUpdateBaseFromJSON)),
    };
}

export function MasterItemUpdateToJSON(json: any): MasterItemUpdate {
    return MasterItemUpdateToJSONTyped(json, false);
}

export function MasterItemUpdateToJSONTyped(value?: MasterItemUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(MasterItemUpdateBaseToJSON)),
    };
}

